import { useState } from 'react';
import { Button, Dialog, DialogType, Flex } from 'components';
import { ButtonColors } from 'types';
import { RecoveryNotice } from './recovery-guidance';

// Mounted only for recovery, never while healthy payment/signing is active.
export function RecoveryAttention({ notice, onContinue }: {
  notice: RecoveryNotice; onContinue: () => void;
}) {
  const [open, setOpen] = useState(true);
  const instructions = notice.description.split(/(?<=[.!?])\s+/);
  const guidance = (popup = false) => <div style={{ lineHeight: 1.6 }}>
    <ul style={{ margin: 0, paddingLeft: 22, display: 'grid', gap: 10 }}>
      {instructions.filter(text => !/^do not /i.test(text)).map(text => <li key={text}>{popup ? text.replace('Then click Credit to check the existing payment and continue checkout.', 'Choose Check payment and continue below.').replace('Click Credit to check it and continue checkout.', 'Choose Check payment and continue to confirm the signature.').replace('Click Credit to finish saving it and continue checkout.', 'Choose Check payment and continue to finish saving it.').replace('Click Credit to continue, then', 'Choose Check payment and continue, then') : text}</li>)}
    </ul>
    {instructions.filter(text => /^do not /i.test(text)).map(text =>
      <p key={text} style={{ margin: '16px 0 0', paddingTop: 14, borderTop: '1px solid #e5c27b', fontWeight: 800, textTransform: 'uppercase' }}>{text}</p>
    )}
  </div>;
  const resume = () => { setOpen(false); onContinue(); };
  return <>
    <section role="status" aria-live="polite" aria-label={notice.title}
      style={{ gridColumn: '1 / -1', order: -1, padding: 24, borderRadius: 12,
        background: '#fff6e5', border: '1px solid #d7a342', borderLeft: '6px solid #a66b00', color: '#3b2b10' }}>
      <h3 style={{ margin: '0 0 12px' }}>{notice.title}</h3>
      <div style={{ maxWidth: 640 }}>{guidance()}</div>
    </section>
    <Dialog open={open} onClose={() => setOpen(false)} type={DialogType.Complex}
      title={notice.title} width="560px" closeOnDocumentClick={false} closeOnEscape={false} showCloseButton={false}>
      {() => <Flex column gap={20}>
        {guidance(true)}
        {notice.canContinue !== false && <Button text="Check payment and continue" onClick={resume} />}
        <Button colorType={ButtonColors.LightBlue} text="Back to checkout" onClick={() => setOpen(false)} />
      </Flex>}
    </Dialog>
  </>;
}
